import { mapGetters, mapMutations } from 'vuex';
import { plansof } from '@/utils/chain';
import { BASE_PLAN_SUB_TYPES, planTypes } from '@/common/constants';
import { ZOOM_MEETING_SUB_TYPES } from '@/plans/ZOOM_MEETING/common/utils';
import { ZOOM_MEETING_PRO_MIN_LICENSE, BILLING_CYCLE } from '@/common/constants';
import { isShowBizCard } from '@/plans/ZOOM_MEETING/common/utils';
import { logger } from '@/utils/log';
let messageIns = null,
  messageIns2 = null;
export default {
  computed: {
    ...mapGetters(['getSelectedPlansCartInfo', 'fromCampaignLink', 'plansofBizBundle']),
    isMixMatch(){
      return plansof(this.getSelectedPlans).type(planTypes.ZOOM_MEETING).category(BASE_PLAN_SUB_TYPES.BIZ).has()
    },
    isSingleCallingPlan(){
      return plansof(this.getSelectedPlans).type(planTypes.ZOOM_ONE_BUNDLE).has(1)
    },
    minCallingPlan(){
      return (this.isSingleCallingPlan && !this.isMixMatch ) ? ZOOM_MEETING_PRO_MIN_LICENSE : 1;
    },
    minLicense() {
      return ZOOM_MEETING_PRO_MIN_LICENSE;
    },
    isShowBizCard() {
      return isShowBizCard();
    }
  },
  watch: {
    minCallingPlan(){
      this.$nextTick(()=>{
        this.$refs.regionsSelect.initData()
      })
    }
  },
  created() {
    this.$watch(
      'getSelectedPlansCartInfo',
      (cur, prev) => {
        if (!this.isShowBizCard) return;
        if (!this.isMixMatch) return;
        logger.log(`auto add`);
        this.$nextTick(() => {
          this.autoAddBiz(cur, prev);
        });
      },
      {
        immediate: true,
        deep: true,
      },
    );
  },
  methods: {
    ...mapMutations(['updateSelectPlans', 'updateSelectPlan']),
    autoAddBiz(cur, prev) {
      // there are two case need to focus
      // 1. ZOOM_MEETING_PRO_MIN_LICENSE zoom one biz plus licenses without zoom one biz
      // 2. both have zoom one biz and zoom one biz plus
      const plans = plansof(cur).type(planTypes.ZOOM_MEETING, planTypes.ZOOM_ONE_BUNDLE);
      const meetingPlan = plans.clone().type(planTypes.ZOOM_MEETING).get();
      const meetingLicenses = plans.clone().type(planTypes.ZOOM_MEETING).sum('license');
      const bundlePlan = plans.clone().type(planTypes.ZOOM_ONE_BUNDLE).get();
      const bundleLicenses = plans.clone().type(planTypes.ZOOM_ONE_BUNDLE).sum('license');
      const margin = this.minLicense - bundleLicenses - meetingLicenses - this.plansofBizBundle.freeTrialLicenses;
      if (margin <= 0) return;
      const prevMeetingPlan = prev && plansof(prev).type(planTypes.ZOOM_MEETING).get();
      if (prevMeetingPlan?.length) {
        // when downgrade zoom one biz license or click remove zoom one biz plan
        if (prevMeetingPlan[0].selected_number > (meetingPlan?.[0]?.selected_number || 0)) {
          // check is disabled'
          const callingPlan = this.callingPlanRegions.filter(p => !p.disabled);
          if (!callingPlan.length) {
            this.addAnotherRegion();
          } else {
            callingPlan[0].number += margin;
          }
          this.$nextTick(() => {
            this.$refs.regionsSelect.initData();
          });
          if (messageIns && !messageIns.closed) return;
          messageIns = this.showMessageBox(
            this.$t('billing.zobizplus.auto_add_message', [this.title, this.minLicense]),
          );
          return;
        }
      }
      // update or add biz
      const bizPlan = meetingPlan.length
        ? meetingPlan[0]
        : plansof(this.planMapFlat)
            .category(ZOOM_MEETING_SUB_TYPES.BIZ)
            .cycle(bundlePlan[0].billingCycle || BILLING_CYCLE.ANNUAL)
            .get(0);
      this.updateSelectPlan({
        plan_code: bizPlan.plan_code,
        cartInfo: { selected_number: margin + bizPlan.cartInfo.selected_number },
      });
      this.$root.$emit('trigger-add-zoom-one');
      if (messageIns2 && !messageIns2.closed) return;
      messageIns2 = this.showMessageBox(
        this.$t('billing.zobizplus.auto_add_message', [this.$t(bizPlan.planNameKey), this.minLicense]),
      );
    },
    showMessageBox(message) {
      return this.$message({
        message,
        showClose: true,
        iconClass: 'zm-icon-info',
        dangerouslyUseHTMLString: true,
        duration: 0,
        customClass: 'zoom-one-boundle__auto-add',
      });
    },
  },
};
